export const createZoneEntity = ({
  id,
  name,
}) => ({
  id,
  name,
});
